var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal',{attrs:{"disabled":_vm.disabled,"to":_vm.target}},[(!_vm.disabled)?[_vm._t("default")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }